<template>
  <form
    class="mt-4"
    v-if="form"
    @submit.prevent="submit"
    @keydown="form.onKeydown($event)"
  >
    <div class="row bg-white pt-3">
      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="date_debut"
            >Date debut <span class="text-danger">*</span></label
          >
          <date-picker
            v-model="form.date_debut"
            name="date_debut"
            placeholder="Date"
            lang="fr"
            format="DD/MM/YYYY"
            value-type="DD/MM/YYYY"
          ></date-picker>
          <input
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('date_debut'),
            }"
            type="hidden"
          />
          <has-error :form="form" field="date_debut"></has-error>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="date_fin"
            >Date fin <span class="text-danger">*</span></label
          >
          <date-picker
            v-model="form.date_fin"
            name="date_fin"
            placeholder="Date"
            lang="fr"
            format="DD/MM/YYYY"
            value-type="DD/MM/YYYY"
          ></date-picker>
          <input
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('date_fin'),
            }"
            type="hidden"
          />
          <has-error :form="form" field="date_fin"></has-error>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="horaire"
            >Horaires <span class="text-danger">*</span></label
          >
          <v-custom-select
            label="nom"
            id="horaire"
            :options="horaires"
            :reduce="(horaire) => horaire.uuid"
            v-model="form.horaire"
            placeholder="type de echange"
          >
            <template v-slot:option="{ nom }">
              <h5 style="margin: 0">{{ nom }}</h5>
            </template>
            <template #no-options> Aucune données </template>
            <template #search="{ attributes, events }">
              <input
                class="custom-select-height vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-custom-select>
          <input
            type="hidden"
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('horaire'),
            }"
          />
          <has-error :form="form" field="horaire"></has-error>
        </div>
      </div>
      <div class="col-md-12 col-lg-12 mt-n1">
        <div class="form-group">
          <label for="commentaire">Commentaire </label>
          <textarea
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('commentaire'),
            }"
            id="commentaire"
            v-model="form.commentaire"
            type="text"
            placeholder="Commentaire"
            maxlength="100"
          ></textarea>
          <has-error :form="form" field="commentaire"></has-error>
        </div>
      </div>
      <div class="col-12">
        <h5 class="text-center">
          <i class="fa fa-users mr-2"></i> Equipe de nettoyage
        </h5>
        <div
          class="row d-flex flex-column justify-content-center align-items-center"
        >
          <div class="col-md-6 mt-n1">
            <div class="form-group">
              <label for="employe">Employé</label>
              <v-custom-select
                label="nom"
                id="employe"
                :options="emps"
                :reduce="(employe) => employe.uuid"
                v-model="selectedEmploye"
                @input="onEmployeSelect"
                placeholder="Selectionner employé"
              >
                <template v-slot:option="{ nom }">
                  <h5 style="margin: 0">{{ nom }}</h5>
                </template>
                <template #no-options> Aucune données </template>
                <template #search="{ attributes, events }">
                  <input
                    class="custom-select-height vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-custom-select>
              <input
                type="hidden"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('horaire'),
                }"
              />
              <has-error :form="form" field="horaire"></has-error>
            </div>
          </div>
          <div class="col-md-12 col-lg-8">
            <ul class="list-group">
              <li
                v-for="(emp, index) in selectedEmployes"
                :key="emp.uuid"
                class="list-group-item"
              >
                <div class="d-flex justify-content-between">
                  <span><i class="fa fa-user mr-2"></i> {{ emp.nom }}</span>
                  <button
                    @click.prevent="removeEmploye(emp.uuid)"
                    type="button"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </div>
                <p
                  class="text-danger mt-1 mb-0 font-size-8"
                  v-if="form.errors.has('equipe.' + index)"
                >
                  {{ form.errors.get('equipe.' + index) }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-n1 mb-4">
      <div class="col-md-12 text-right">
        <button
          v-if="!edit"
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="list"
        >
          Voir planning
        </button>

        <ButtonLoader
          :busy="form.busy"
          type="submit"
          customClass="btn btn-custom-primary w-40"
          loadText="Traitement en cours..."
          :Text="`${edit ? 'Enregistrer' : 'Créer'}`"
          style="min-width: 100px"
        ></ButtonLoader>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from 'vue2-datepicker';
// import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    horaires: {
      type: Array,
      default() {
        return [];
      },
    },
    employes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: null,
      VueEditorToolbar,
      selectedEmployes: [],
      selectedEmploye: null,
    };
  },
  components: {
    DatePicker,
    // VueEditor,
  },

  methods: {
    /**
     * Modal note
     */

    init() {
      this.form = this.propForm;
    },
    submit() {
      this.form.equipe = this.selectedEmployes.map((e) => e.uuid);
      this.$emit('submit', this.form);
    },
    list() {
      this.$emit('list');
    },
    isEmployeAdded(uuid) {
      return this.selectedEmployes.some((emp) => emp.uuid === uuid);
    },
    onEmployeSelect(emp) {
      if (!this.isEmployeAdded(emp)) {
        this.selectedEmployes.push(this.employes.find((e) => e.uuid === emp));
        this.selectedEmploye = null;
      }
    },
    removeEmploye(uuid) {
      if (this.isEmployeAdded(uuid)) {
        let index = this.selectedEmployes.indexOf(
          this.selectedEmployes.find((e) => e.uuid === uuid)
        );
        this.selectedEmployes.splice(index, 1);
      }

      this.form.clear();
    },
  },
  computed: {
    emps() {
      return this.employes.filter((e) => !this.isEmployeAdded(e.uuid));
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
